

export function initAccordionsOld(){
    const accordionWrapper=document.querySelector('.accordion-wrapper-old');
    if(!accordionWrapper) return;

    const accordions=accordionWrapper.children;
    if(!accordions.length) return;


    for(let acc of accordions){
        const firstHeader=acc.querySelector('h3');
        if(!firstHeader) continue;
        const headerContent=firstHeader.innerHTML;

        if(acc!==firstHeader.parentElement) return;
        acc.removeChild(firstHeader);
        const otherChildren=[...acc.children];

        if(!otherChildren.length) continue;


        acc.innerHTML=`<h6 class="collapse-head">${headerContent}</h6>`;
        const collapseContent=document.createElement('div');
        collapseContent.classList.add('collapse-content');

        for(let c of otherChildren){
            collapseContent.appendChild(c);
        }

        acc.appendChild(collapseContent);
    }

}


initAccordionsOld();